import { identifiersMessages } from 'src/features/identifiers/utils/messages';
import { IDENTIFIER_VALIDITY } from 'src/features/identifiers/utils/types';
import { BadgeOption } from 'src/registry/types/badges';
import { ICON_MAP } from 'src/utils/constants';

export const identifierValidityBadgeOptions: Record<IDENTIFIER_VALIDITY, BadgeOption> = {
    [IDENTIFIER_VALIDITY.FOREVER]: {
        label: identifiersMessages.forever,
        icon: ICON_MAP.FOREVER,
        theme: 'yellow',
    },
    [IDENTIFIER_VALIDITY.ONE_TIME]: {
        label: identifiersMessages.oneTime,
        icon: ICON_MAP.SINGLE,
        theme: 'purple',
    },
    [IDENTIFIER_VALIDITY.TIME_SENSITIVE]: {
        label: identifiersMessages.timeSensitive,
        icon: ICON_MAP.TIME_SENSITIVE,
        theme: 'orange',
    },
};
